import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { superuserGroupMembersBackend } from './superuser-group-members.backend';
import { superuserGroupMembersReducer } from './superuser-group-members.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'superuserGroupMembers',
      superuserGroupMembersReducer,
    ),
    BackendModule.forFeature(
      'superuserGroupMembers',
      superuserGroupMembersBackend,
    ),
  ],
})
export class DatastoreSuperuserGroupMembersModule {}
